export default "__VITE_ASSET__tPby08wp__"